export const PURPLE = 'purple';
export const TEAL = 'teal';
export const RED = 'red';
export const GREEN = 'green';

export const ME_COLOR = PURPLE;
